import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const VendorsList = () => {
  const [vendors, setVendors] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("latest");
  const [currentPage, setCurrentPage] = useState(1);

  const PER_PAGE = 8;

  useEffect(() => {
    fetch("https://ecom.brightcodeapp.com/wp-json/dokan/v1/stores?per_page=100")
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setVendors(data);
          setFiltered(data);
        }
      });
  }, []);

  useEffect(() => {
    let list = [...vendors];

    // 🔍 Search
    if (search) {
      list = list.filter(v =>
        v.store_name.toLowerCase().includes(search.toLowerCase()) ||
        String(v.id).includes(search)
      );
    }

    // 🔃 Sort
    if (sort === "latest") {
      list.sort((a, b) => b.id - a.id);
    } else {
      list.sort((a, b) => a.id - b.id);
    }

    setFiltered(list);
    setCurrentPage(1);
  }, [search, sort, vendors]);

  // 📄 Pagination Logic
  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const start = (currentPage - 1) * PER_PAGE;
  const currentVendors = filtered.slice(start, start + PER_PAGE);

  return (
    <section className='vendors-list py-80'>
      <div className='container container-lg'>

        {/* 🔝 Top Bar */}
        <div className='flex-between flex-wrap gap-8 mb-40'>
          <span className='text-neutral-600 fw-medium px-40 py-12 rounded-pill border border-neutral-100'>
            Showing {start + 1}-{Math.min(start + PER_PAGE, filtered.length)} of {filtered.length} results
          </span>

          <div className='flex-align gap-16'>
            <form className='search-form__wrapper position-relative d-block' onSubmit={e => e.preventDefault()}>
              <input
                type='text'
                className='search-form__input common-input py-13 ps-16 pe-18 rounded-pill pe-44'
                placeholder='Search vendors by name or ID...'
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              <button
                type='submit'
                className='w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8'
              >
                <i className='ph ph-magnifying-glass' />
              </button>
            </form>

            <div className='flex-align gap-8'>
              <span className='text-gray-900 flex-shrink-0'>Sort by:</span>
              <select
                className='common-input form-select rounded-pill border border-gray-100 d-inline-block ps-20 pe-36 h-48 py-0 fw-medium'
                value={sort}
                onChange={e => setSort(e.target.value)}
              >
                <option value="latest">Latest</option>
                <option value="old">Old</option>
              </select>
            </div>
          </div>
        </div>

        {/* 🧱 Vendor Cards */}
        <div className='row gy-4 vendor-card-wrapper'>
          {currentVendors.map(vendor => (
            <div key={vendor.id} className='col-xxl-3 col-lg-4 col-sm-6'>
              <div className='vendor-card text-center px-16 pb-24'>
                <div>
                  <img
                    src={vendor.gravatar || "assets/images/thumbs/vendor-logo1.png"}
                    alt={vendor.store_name}
                    className='vendor-card__logo m-12'
                  />
                  <h6 className='title mt-32'>
                    <Link to={`/vendor-details/${vendor.id}`}>
                      {vendor.store_name}
                    </Link>
                  </h6>
                  <span className='text-heading text-sm d-block'>
                    {vendor.address?.city || "Fast Delivery"}
                  </span>
                  <Link
                    to={`/shop?vendor=${vendor.id}`}
                    className='bg-white text-neutral-600 hover-bg-main-600 hover-text-white rounded-pill py-6 px-16 text-12 mt-8 d-inline-block'
                  >
                    Visit Store
                  </Link>
                </div>

                <div className='vendor-card__list mt-22 flex-center flex-wrap gap-8'>
                  {vendor.banner && (
                    <div className='vendor-card__item bg-white rounded-circle flex-center'>
                      <img src={vendor.banner} alt='' />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 📄 Pagination */}
        <ul className='pagination flex-center flex-wrap gap-16 mt-40'>
          <li className='page-item'>
            <button
              className='page-link h-64 w-64 flex-center text-xxl rounded-circle fw-medium border border-gray-100'
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(p => p - 1)}
            >
              <i className='ph-bold ph-arrow-left' />
            </button>
          </li>

          {[...Array(totalPages)].map((_, i) => (
            <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
              <button
                className='page-link h-64 w-64 flex-center text-md rounded-circle fw-medium border border-gray-100'
                onClick={() => setCurrentPage(i + 1)}
              >
                {String(i + 1).padStart(2, "0")}
              </button>
            </li>
          ))}

          <li className='page-item'>
            <button
              className='page-link h-64 w-64 flex-center text-xxl rounded-circle fw-medium border border-gray-100'
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(p => p + 1)}
            >
              <i className='ph-bold ph-arrow-right' />
            </button>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default VendorsList;
